import React from "react";
import styles from "./index.module.scss";

interface ListCardInfoProps {
    children: React.ReactNode;
}

export function ListCardInfo({ children }: ListCardInfoProps) {
    return <div className={styles.root}>{children}</div>;
}
